module.exports = __webpack_public_path__ + "img/providers.1b29ea9.png";